import type { Location } from "@prisma/client";
import { useContext } from "react";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import * as RadioCard from "~/components/ui/radio-card";
import { Label } from "~/components/ui/label";

export function LocationSelect({
  locations,
}: {
  locations: Pick<Location, "id" | "name" | "color">[];
}) {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const {
    selectedLocationId,
    setSelectedLocationId,
    setSelectedBarberId,
    setSelectedDate,
    setSelectedServiceIds,
    setSelectedTime,
  } = context;

  return (
    <div>
      <Label className="px-6" htmlFor="location-select">
        Location
      </Label>
      <div className="mt-2" />
      <RadioCard.Root
        className="px-6"
        id="location-select"
        onValueChange={(value) => {
          setSelectedLocationId(value);
          setSelectedBarberId("");
          setSelectedServiceIds([]);
          setSelectedDate("");
          setSelectedTime("");
        }}
        value={selectedLocationId}
      >
        {locations.map((location) => (
          <RadioCard.Item
            color={location.color}
            key={location.id}
            value={location.id}
          >
            <RadioCard.Indicator />
            <span>{location.name}</span>
          </RadioCard.Item>
        ))}
      </RadioCard.Root>
    </div>
  );
}
